import carousel from '@/js/util/symbols/carousel'

export default {
  inject: { carousel },

  computed: {
    currentActiveIndex() {
      return this.carousel.currentItemIndex === this.$vnode.key
    },
  },

  methods: {
    handleButtonClick() {
      this.carousel.$emit('set:item', this.carousel.items[this.$vnode.key])
    },
  },

  render(createElement) {
    const elementData = {
      on: {
        click: this.handleButtonClick,
      },
      class:
        !this.currentActiveIndex || 'CarouselContainerControl--active',
    }
    return createElement('button', elementData, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/carousel/CarouselContainerControl.js